import { MarketplaceKeys } from '@config/keys/shop.keys';
import { IAddress } from './address.model';
import { IDistributionMode } from './shop.model';
import { ColorsGroup } from './marketplace-colors.model';
import { MarketPlacePluginValues } from './plugin.model';

export interface IFirebaseTenant {
  firebase_tenant_id?: string;
  id: string;
  name: string;
}

export interface IUIConfigFont {
  family: string;
  url: string;
  local?: boolean;
  /** Default font-weight for --ui-font-{key}-weight (must match an @font-face weight when using local fonts). */
  weight?: number;
}

export interface IUIConfigFontList {
  brand: IUIConfigFont;
  accent: IUIConfigFont;
  base: IUIConfigFont;
}

/** Palette shade → hex, e.g. `{ '600': '#408080' }`. */
export type IUIColorPalette = Record<string, string>;

/** Named palettes → shades, e.g. `{ primary: { '600': '#408080' } }`. */
export type IUIColors = Record<string, IUIColorPalette>;

export interface IUIConfig {
  colors: IUIColors;
  fonts?: IUIConfigFontList;
  custom_css: string[];
}

export interface IMarketplaceUserInterface {
  colors: IUIColors;
  fonts?: IUIConfigFontList;
  custom_css: string[];
  translations?: any;
}

export interface IPageConfig {
  id?: string;
  path: string;
  block?: any;
  guards?: Array<string>;
  data?: any;
  children?: Array<IPageConfig>;
  parent?: string;
  redirect_to?: string;
}

export interface IBlockConfig {
  id: string;
  type: string;
  data?: any;
}

export interface DoodModalConfig {
  handle: string;
  block: string;
  /** Optional shell props merged into block-factory injectData at runtime. */
  data?: Record<string, unknown>;
}

export interface ILayout {
  powered_by: any;
}

// TODO: Move to a marketplace enum file
export enum DoodMarketplaceCartScope {
  marketplace = 'MARKETPLACE',
}

export interface DoodOrganizationModel {
  id?: string;
}

export interface DoodMarketplaceModel {
  [MarketplaceKeys.Id]: string;
  [MarketplaceKeys.Name]: string;
  [MarketplaceKeys.Available]: boolean;
  [MarketplaceKeys.CartScope]: string;
  [MarketplaceKeys.DistributionModes]: IDistributionMode[];
  [MarketplaceKeys.Address]?: IAddress;
  [MarketplaceKeys.Plugins]?: Array<MarketPlacePluginValues>;
  [MarketplaceKeys.Currency]: string;
  /** `legacy` (embedded CB v1) or `v2` (compiled spec from api-php). */
  content_builder_version?: 'legacy' | 'v2';
  /** camelCase alias returned by some Symfony endpoints. */
  contentBuilderVersion?: 'legacy' | 'v2';
  user_interface?: IMarketplaceUserInterface;
  white_label?: { ui: { colors: IUIColors } };
  // ui?: IUIConfig;
  layout?: ILayout;
  pages?: Array<IPageConfig>;
  blocks?: Array<IBlockConfig>;
  modals?: Array<DoodModalConfig>;
  [MarketplaceKeys.Locales]: DoodMarketplaceLocale[];
  [MarketplaceKeys.DefaultLocale]?: DoodMarketplaceLocale;
  [MarketplaceKeys.Timezone]?: string;
  [MarketplaceKeys.Country]: string;
  [MarketplaceKeys.Domains]: string[];
  [MarketplaceKeys.AuthMode]?: string;
  [MarketplaceKeys.TipsAllowed]: boolean;
  [MarketplaceKeys.Capabilities]: { type: string }[];
  [MarketplaceKeys.FirebaseTenant]?: IFirebaseTenant;
  [MarketplaceKeys.Colors]?: ColorsGroup;
  [MarketplaceKeys.Organization]?: DoodOrganizationModel;
  [MarketplaceKeys.DeliveryProvider]?: string;
}

export interface IPushShop {
  logo?: string;
  name: string;
  shop: string;
  type: string;
  slug?: string;
  eat_in: boolean;
}

export interface DoodMarketplaceLocale {
  id: string;
  locale: string;
  name: string;
}
